import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Settings as SettingsIcon, ArrowLeft } from 'lucide-react';
import FeatureFlagsSection from '../components/admin/FeatureFlagsSection';
import FixedCostsSection from '../components/admin/FixedCostsSection';

const AdminFeatureFlagsPage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    // Check if user is admin
    if (user?.role !== 'admin') {
      navigate('/');
      return;
    }
  }, [user?.role, navigate]);

  if (user?.role !== 'admin') {
    return null;
  }

  return (
    <div className="container mx-auto px-4 py-8 max-w-6xl">
      <div className="bg-white rounded-lg shadow-md p-6 mb-6 border-2 border-blue-200">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <button
              onClick={() => navigate('/admin')}
              className="mr-4 p-2 hover:bg-gray-100 rounded-md transition-colors"
              aria-label="Back to dashboard"
            >
              <ArrowLeft className="h-5 w-5 text-gray-600" />
            </button>
            <SettingsIcon className="h-8 w-8 text-black mr-3" />
            <h1 className="text-3xl font-bold text-black">Feature Flags & Cost Management</h1>
          </div>
        </div>

        <p className="text-gray-600 mb-6">
          Manage feature flags, track API usage costs, and monitor platform infrastructure expenses.
        </p>

        {/* Feature Flags Section */}
        <FeatureFlagsSection />
        
        {/* Fixed Costs Section */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <FixedCostsSection />
        </div>
      </div>
    </div>
  );
};

export default AdminFeatureFlagsPage;

